import { render } from "./AdminOverviewView.vue?vue&type=template&id=56ae661e&scoped=true"
import script from "./AdminOverviewView.vue?vue&type=script&lang=js"
export * from "./AdminOverviewView.vue?vue&type=script&lang=js"

import "./AdminOverviewView.vue?vue&type=style&index=0&id=56ae661e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56ae661e"]])

export default __exports__